import {ThemeColorPath} from 'platform/foundation';
import {match} from 'ts-pattern';

import {AvailabilityStatus} from './AvailabilityStatus';

export function getAvailabilityStatusColor(status: AvailabilityStatus): ThemeColorPath {
  return match<AvailabilityStatus, ThemeColorPath>(status)
    .with('available', () => 'palettes.green.60.100')
    .with('away', () => 'palettes.yellow.60.100')
    .with('absent', () => 'palettes.red.60.100')
    .exhaustive();
}
